import { render } from "./Edifici.vue?vue&type=template&id=429415dd"
import script from "./Edifici.vue?vue&type=script&lang=js"
export * from "./Edifici.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__